import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import View from './view';
import * as OrganizationSwitcherSelectors from 'shared_redux/selectors/view/organization_switcher';

const mapStateToProps = (state) => {
    const currentOrganization = OrganizationSwitcherSelectors.getCurrentOrganization(state);
    return {
        currentOrganization,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

const Container = connect(
    mapStateToProps,
    mapDispatchToProps
)(View);

export default Container;
